var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#051D39",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 8,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 14,
    r: 2
  }))));
}

export default SvgMore;